/** @format */

import { createFeatureSelector, createSelector } from '@ngrx/store';

import { ProductSelectionState } from '@pdp/data-access/interfaces';
import { selectAllProductSkus, selectResolvedSku } from '../product-selection.selectors';
import { WarrantyButtonState } from '@pdp/data-access/enums';
import { ProductSku } from '@shared/data-access/interfaces';

export const selectState = createFeatureSelector<ProductSelectionState>('productSelection');

export const selectWarrantiesState = createSelector(selectState, (state) => state?.warranties);

export const selectSelectedWarranty = createSelector(
	selectWarrantiesState,
	(state) => state?.selectedWarranty
);

// Derive this from all warranties map when we have data available
export const selectSelectedWarrantyDisplayName = createSelector(() => '2 Year Plan');

const isWarrantyEligible = (sku: ProductSku) => {
	return !!sku?.descriptiveAttributes?.some(
		(attr) => attr.identifier === '8881' && String(attr.value).toLowerCase() === 'true'
	);
};

export const selectIsProductWarrantyEligible = createSelector(selectAllProductSkus, (allSkus) =>
	allSkus?.some((sku) => isWarrantyEligible(sku))
);

export const selectIsResolvedSkuWarrantyEligible = createSelector(
	selectResolvedSku,
	(resolvedSku) => isWarrantyEligible(resolvedSku)
);

export const selectWarrantyButtonState = createSelector(
	selectResolvedSku,
	selectIsResolvedSkuWarrantyEligible,
	selectSelectedWarranty,
	(resolvedSku, isResolvedSkuWarrantyEligible, selectedWarranty) => {
		if (!resolvedSku) {
			return WarrantyButtonState.BeforeSkuResolve;
		}

		if (!isResolvedSkuWarrantyEligible) {
			return WarrantyButtonState.WarrantyNotAvailable;
		}

		if (selectedWarranty) {
			return WarrantyButtonState.WarrantySelected;
		}

		// Once we make API call, check call state here and when successful, make sure we have warranties
		// for the resolved sku before making available

		return WarrantyButtonState.WarrantyAvailable;
	}
);
